import { createContext, Dispatch, SetStateAction } from 'react';

export const bannerHeightContext = createContext<[number, Dispatch<SetStateAction<number>>]>([0, () => { throw new Error('you\'re not in a bannerHeightContext'); }]);
